import React, { PropsWithChildren, useEffect, useState } from 'react';
import { LinkedInEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedLinkedInProps declares any input properties required for this component.
 */
export interface IEmbedLinkedInProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedLinkedIn is a React functional component for displaying a LinkedIn social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedLinkedIn: React.FC<IEmbedLinkedInProps> = (props: IEmbedLinkedInProps) => {
  EmbedLinkedIn.displayName = 'EmbedLinkedIn';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedLinkedIn. Entered EmbedLinkedIn`);

  const { url, postWidth, postHeight } = props;

  return (
    <>
      <LinkedInEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
